import { notification } from "antd";
import { ReactNode } from "react";

export interface NotificationSuccessOptions {
  message?: string;
  width?: number;
  closable?: boolean;
  notAutoClose?: boolean;
  action?: ReactNode;
  placement?: "topLeft" | "topRight" | "bottomLeft" | "bottomRight";
  backgroundColor?: string;
  color?: string;
  key?: string;
}

const NotificationSuccess = ({
  message = "",
  width = 320,
  closable = false,
  notAutoClose = false,
  action,
  placement = "topRight",
  backgroundColor = "#EEFBF4",
  color = "#17663A",
  key,
}: NotificationSuccessOptions) => {
  notification.success({
    key,
    message: (
      <div className="flex items-start flex-col gap-3">
        <span style={{ color }}>{message}</span>
        {action || null}
      </div>
    ),
    description: "",
    placement,
    duration: notAutoClose ? 0 : 3,
    style: {
      width,
      backgroundColor,
      padding: "10px 20px",
      borderRadius: "6px",
    },
    closable,
  });
};

export default NotificationSuccess;
